module.exports = __webpack_public_path__ + "static/media/google_00.240931cc.svg";